import { buildApiUrl } from '../utils/apiUtils';

export interface HelpRequestPayload {
  Name: string;
  Email: string;
  Type: string;
  Note?: string;
  Phone?: string;
}

export async function requestHelp(data: HelpRequestPayload): Promise<Response> {
  const url = buildApiUrl('/api/User/RequestHelp');
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
}
